import { useCallback, useEffect, useRef, useState } from "react";
import type { IdleAnimation } from "../types";

const IDLE_TIMEOUT = 10_000;

export function useIdleTimer(suspended: boolean = false) {
  const [idleAnimation, setIdleAnimation] = useState<IdleAnimation>("none");
  const timerRef = useRef<number | undefined>(undefined);

  const setIdleState = useCallback(() => {
    setIdleAnimation("reading");
  }, []);

  const clearTimer = useCallback(() => {
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
      timerRef.current = undefined;
    }
  }, []);

  const reset = useCallback(() => {
    clearTimer();
    setIdleAnimation("none");
    if (suspended) return;
    timerRef.current = window.setTimeout(setIdleState, IDLE_TIMEOUT);
  }, [clearTimer, setIdleState, suspended]);

  useEffect(() => {
    if (suspended) {
      clearTimer();
      setIdleAnimation("none");
    } else {
      reset();
    }
    return () => {
      clearTimer();
    };
  }, [reset, clearTimer, suspended]);

  const registerActivity = useCallback(() => {
    reset();
  }, [reset]);

  return { idleAnimation, registerActivity };
}
